"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorStrings = exports.dashboardStrings = exports.SupportSettingsStrings = exports.walletStrings = exports.approvalsStrings = exports.sessionUserDetailsStrings = exports.sessionStrings = exports.sideMenuStrings = exports.cardDetailStrings = exports.enrollSourceCardStrings = exports.teamSettingsPeopleStrings = exports.teamSettingsCardStrings = exports.companySettingsCardStrings = exports.companySettingsCodingStrings = exports.teamInfoStrings = exports.addPeopleStrings = exports.userDetailsStrings = exports.validationStrings = exports.messageStrings = exports.notificationStrings = exports.peopleTableStrings = exports.navigationStrings = exports.invitePeopleStrings = exports.inputStrings = exports.teamSettingsOverviewStrings = exports.companySettingsTeamsStrings = exports.companySettingsOverviewStrings = exports.teamHeaderTabsStrings = exports.companyHeaderTabsStrings = exports.pageHeadersStrings = void 0;
const lexico_1 = __importDefault(require("@tradeshift/lexico"));
// TODO construct Lexico with translations map
const lexico = new lexico_1.default();
exports.pageHeadersStrings = {
    COMPANY_SETTINGS_PAGE_HEADER: ({ headerName }) => `${lexico.tr('Company Settings')}: ${headerName}`,
    TEAM_SETTINGS_PAGE_HEADER: ({ headerName }) => `${lexico.tr('Team Settings')} - ${headerName}`,
};
exports.companyHeaderTabsStrings = {
    COMPANY_SETTINGS_OVERVIEW_HEADER_TAB: lexico.trc('Tab label', 'Overview'),
    COMPANY_SETTINGS_TEAMS_HEADER_TAB: lexico.trc('Tab label', 'Teams'),
    COMPANY_SETTINGS_SOURCE_CARDS_HEADER_TAB: lexico.trc('Tab label', 'Source cards'),
    COMPANY_SETTINGS_PHYSICAL_CARDS_HEADER_TAB: lexico.trc('Tab label', 'Physical cards'),
    COMPANY_SETTINGS_CODING_LISTS_HEADER_TAB: lexico.trc('Tab label', 'Accounting codes'),
};
exports.teamHeaderTabsStrings = {
    TEAM_SETTINGS_OVERVIEW_HEADER_TAB: lexico.trc('Tab label', 'Overview'),
    TEAM_SETTINGS_SOURCE_CARDS_HEADER_TAB: lexico.trc('Tab label', 'Source cards'),
    TEAM_SETTINGS_PHYSICAL_CARDS_HEADER_TAB: lexico.trc('Tab label', 'Physical cards'),
    TEAM_SETTINGS_PEOPLE_HEADER_TAB: lexico.trc('Tab label', 'People'),
    TEAM_SETTINGS_CODING_LISTS_HEADER_TAB: lexico.trc('Tab label', 'Accounting codes'),
};
exports.companySettingsOverviewStrings = {
    ADD_ADMIN_TITLE: lexico.trc('Button', 'Add Admin'),
    CANCEL_BUTTON_TEXT: lexico.trc('Button', 'Cancel'),
    HEADER_BUTTON_NAME: lexico.trc('Button', 'Save Changes'),
    COMPANY_ADMINS_LABEL: lexico.trc('Title', 'Company Admins'),
    COMPANY_NAME_LABEL: lexico.trc('Input Label', 'Company name'),
    COMPANY_NAME_LENGTH_ERROR: lexico.trc('Error', 'Length of company name should not be greater than 40 characters'),
    HEADER_TITLE: lexico.trc('Component title', 'Company Settings'),
    ADD_SELECTED_BUTTON_TEXT: lexico.trc('Button', 'Add selected'),
    ADD_COMPANY_ADMIN_BUTTON: lexico.trc('Button', 'Add Company Admin'),
    INVITE_ADMIN_BUTTON_TEXT: lexico.trc('Button', 'Invite new admin user'),
    COMPANY_SETTINGS_SUCCESS: lexico.trc('Save Success', 'Company settings saved.'),
    COMPANY_SETTINGS_ERROR: lexico.trc('Save Error', 'There was an error saving the settings'),
    INVITE_USER_TEXT: ({ role }) => `${lexico.tr('Invite new')} ${role ? role.label.toLowerCase() : 'user'}`,
    ADD_ADMIN_ASIDE_INFO: lexico.trc('Aside Info', 'You can promote one of the team owners listed below to be a company admin or invite a new user.'),
    NO_TEAM_OWNERS_ASIDE_INFO: lexico.trc('Aside Info', 'There are no team owners.'),
    FEATURE_ENABLE_TRANSACTION_RECEIPT_UPLOAD: lexico.trc('Button', 'Enable receipt upload for transactions'),
    FEATURE_ENABLE_DEFAULT_EXPIRATION_DATE: lexico.trc('Button', 'Enable maximum expiration date for virtual card'),
    FEATURE_ENABLE_DEFAULT_EXPIRATION_DATE_ASIDE_TITLE: lexico.trc('Date range label', 'Select duration'),
    FEATURE_ENABLE_DEFAULT_EXPIRATION_DATE_INPUT_PLACEHOLDER: lexico.trc('Input placeholder', 'Select default expiration date range'),
    FEATURE_ENABLE_DEFAULT_EXPIRATION_DATE_TAG: lexico.trc('Validation message', 'This setting will only affect the new cards'),
    FEATURE_ENABLE_DOMAIN_WHITELISTING: lexico.trc('Button', 'Enable email domain whitelisting for invited users'),
    FEATURE_ENABLE_DOMAIN_WHITELISTING_BUTTON_NAME: lexico.trc('Button', 'Add domain'),
    FEATURE_ENABLE_DOMAIN_WHITELISTING_INPUT_PLACEHOLDER: lexico.trc('Input placeholder', 'Example: timbuktu.com'),
    FEATURE_ENABLE_DOMAIN_WHITELISTING_WARNING: lexico.trc('Warning', 'At least one valid domain is required to be able to invite people'),
    FEATURE_PAUSE_VIRTUAL_CARD_CREATION: lexico.trc('Button', 'Pause new virtual cards from being issued'),
    FEATURE_AMEX_APPROVAL_LIMIT: lexico.trc('Input label', 'Max Approval Limit Per Virtual Card'),
    FEATURE_COMPANY_APPROVAL_LIMIT: lexico.trc('Input label', 'Company approval limit'),
    FEATURE_COMPANY_APPROVAL_LIMIT_LABEL_1: lexico.trc('Input Instructions', 'Limit can be overwritten at a team and individual approver level'),
    FEATURE_COMPANY_APPROVAL_LIMIT_LABEL_2: lexico.trc('Input Instructions', 'Teams and individual limits will never exceed the company limit'),
    FEATURE_ENABLE_COMPANY_PEOPLE_VIEW: lexico.trc('Button', 'Enable people view for company admin users'),
    FEATURE_ENABLE_GLOBALIZATION: lexico.trc('Button', 'Enable globalization option in user aside'),
    CONFIRM_ACTION_TITLE: lexico.trc('Form title', 'Confirm action'),
    REMOVE_ADMIN_CONFIRMATION_MESSAGE: ({ name }) => `${lexico.tr('Are you sure you want to remove')} ${name} ${lexico.tr('from being a company administrator?')}`,
    ADD_ADMIN_ERROR: lexico.trc('Adding admin error message', 'There was an error adding the admin, please try again.'),
    REMOVE_ADMIN_SUCCESS: lexico.trc('Remove admin success Message', 'Company Admin has been removed'),
    REMOVE_ADMIN_ERROR: lexico.trc('Remove admin error message', 'There was an error removing the admin, please try again.'),
};
exports.companySettingsTeamsStrings = {
    HEADER_TITLE: lexico.trc('Component title', 'Company Settings'),
    DOWNLOAD_USER_LIST: lexico.trc('Button', 'Download User List'),
    CREATE_NEW_TEAM: lexico.trc('BUTTON', 'Create Team'),
    SAVE_AND_CONTINUE: lexico.trc('BUTTON', 'Save and Continue'),
    SAVE: lexico.trc('BUTTON', 'Save'),
    INVITE_PEOPLE_BUTTON: lexico.trc('BUTTON', 'Invite More People'),
    BACK_BUTTON: lexico.trc('BUTTON', 'Back'),
    VIEW_TEAM_DETAILS: lexico.trc('BUTTON', 'View Team Details'),
    PAUSE_CARD_CREATION: lexico.trc('BUTTON', 'Pause Card Creation'),
    UNPAUSE_CARD_CREATION: lexico.trc('BUTTON', 'Unpause Card Creation'),
    ACTIVATE_TEAM: lexico.trc('BUTTON', 'Activate Team'),
    REACTIVATE_TEAM: lexico.trc('BUTTON', 'Reactivate Team'),
    DE_ACTIVATE_TEAM: lexico.trc('BUTTON', 'Deactivate Team'),
    NOTIFICATION_MESSAGE: lexico.trc('User notification message', 'Deactivating a team will cancel all active virtual cards and none of the team members, ' +
        'managers, or owners will be able to access the team. Only you or another company admin can ' +
        'reactivate a team. Are you sure?'),
    HSBC_NOTIFICATION_MESSAGE: lexico.trc('User notification message', 'Deactivating a team will cancel all active virtual cards and none of the team members ' +
        'or team owners will be able to access the team. Only you or another company admin can ' +
        'reactivate a team. Are you sure?'),
    CONFIRM_ACTION_TITLE: lexico.trc('Form title', 'Confirm action'),
    YES_BUTTON_TEXT: lexico.trc('Button', 'Yes'),
    CANCEL_BUTTON_TEXT: lexico.trc('Button', 'Cancel'),
    WARNING_MESSAGE: lexico.trc('Warning Message', 'There was an error saving the settings for your team. Please Try again.'),
    FEATURE_ENABLE_MULTI_USE_VIRTUAL_CARDS: lexico.trc('Button', 'Enable multi use virtual cards'),
    FEATURE_ENABLE_SINGLE_USE_VIRTUAL_CARDS: lexico.trc('Button', 'Enable single use virtual cards'),
    FEATURE_ENABLE_SUBSCRIPTION_VIRTUAL_CARDS: lexico.trc('Button', 'Enable subscription virtual cards'),
    FEATURE_AMEX_APPROVAL_LIMIT: lexico.trc('Input label', 'Max Approval Limit Per Virtual Card'),
    FEATURE_TEAM_APPROVAL_LIMIT: lexico.trc('Input label', 'Team approval limit'),
    APPROVAL_LIMIT: lexico.tr('Approval limit'),
    TEAM_NAME_TIP: lexico.trc('Data table column tooltip', 'Search by team name'),
    CREATE_TEAM_TITLE: lexico.trc('Title', 'Create team'),
    TEAM_CREATED_BY_NOT_AVAILABLE: lexico.trc('Not available', 'N/A'),
};
exports.teamSettingsOverviewStrings = {
    HEADER_TITLE: lexico.trc('Component title', 'Team Settings'),
    HEADER_BUTTON_NAME: lexico.trc('Button', 'Save Changes'),
    TEAM_NAME_LABEL: lexico.trc('Input Label', 'Team name'),
    TEAM_OWNER_LABEL: lexico.trc('Info Label', 'Team Owners'),
    TEAM_MANAGER_LABEL: lexico.trc('Info Label', 'Team Managers'),
    TEAM_MEMBER_LABEL: lexico.trc('Info Label', 'Team Members'),
    CARD_SETTINGS_LABEL: lexico.trc('Inner Title', 'Card Settings'),
    FEATURE_ENABLE_MULTI_USE_VIRTUAL_CARDS: lexico.trc('Button', 'Enable multi use virtual cards'),
    FEATURE_ENABLE_SINGLE_USE_VIRTUAL_CARDS: lexico.trc('Button', 'Enable single use virtual cards'),
    FEATURE_ENABLE_SUBSCRIPTION_VIRTUAL_CARDS: lexico.trc('Button', 'Enable subscription virtual cards'),
    FEATURE_AMEX_APPROVAL_LIMIT: lexico.trc('Input Label', 'MAX APPROVAL LIMIT PER VIRTUAL CARD'),
    FEATURE_TEAM_APPROVAL_LIMIT: lexico.trc('Input Label', 'TEAM APPROVAL LIMIT'),
    ERROR_AMEX_EXCEEDED_AMOUNT: lexico.trc('Error', 'This amount exceeds the Max Approval Limit Per Virtual Card.'),
    ERROR_EXCEEDED_AMOUNT: lexico.trc('Error', 'This amount exceeds the compnay approval limit.'),
    ERROR_INVALID_FORMAT: lexico.trc('Error', 'Please enter a positive integer or leave empty.'),
    HSBC_ERROR_INVALID_FORMAT: lexico.trc('Error', 'Please enter a positive number or leave empty.'),
    ERROR_CARD_OPTIONS: lexico.trc('Warning message', 'At least one card option should be enabled.'),
    HSBC_ERROR_CARD_OPTIONS: lexico.trc('Warning message', 'At least one card option should be selected.'),
    CONFIRM_ACTION_TITLE: lexico.trc('Form title', 'Confirm action'),
    CONFIRM_MULTI_USE_ACTION_CONTENT: lexico.trc('Aside', 'Disabling multi-use cards will only impact new multi-use cards from being created. Existing multi-use cards will not be affected'),
    CONFIRM_SINGLE_USE_ACTION_CONTENT: lexico.trc('Aside', 'Disabling single-use cards will only impact new single-use cards from being created. Existing single-use cards will not be affected.'),
    CONFIRM_SUBSCRIPTION_ACTION_CONTENT: lexico.trc('Aside', 'Disabling subscriptions cards will only impact new subscriptions cards from being created. Existing subscriptions cards will not be affected.'),
    SAVE_TEAM_SUCCESS_MESSAGE: lexico.trc('Success message', 'Settings saved'),
    SAVE_TEAM_WARNING_MESSAGE: lexico.trc('Warning message', 'There has been a problem saving the team settings. Please try again.'),
};
exports.inputStrings = {
    CARD_HOLDER: lexico.trc('Input Label', 'Card Holder'),
    FIRST_NAME: lexico.trc('Input Label', 'First Name'),
    LAST_NAME: lexico.trc('Input Label', 'Last Name'),
    EMAIL: lexico.trc('Input Label', 'Email'),
    CARD_DETAILS: lexico.trc('Input Label', 'Card Details'),
    CARD_NAME: lexico.trc('Input Label', 'Card Name'),
    CARD_NAME_PLACEHOLDER: lexico.trc('Input placeholder', 'A friendly nickname, e.g. Marketing Card'),
    CARD_NUMBER: lexico.trc('Input Label', 'Card Number'),
    EXP_MONTH: lexico.trc('Input Label', 'Expiration Month'),
    EXP_MONTH_PLACEHOLDER: lexico.trc('Input placeholder', 'Select a month'),
    EXP_YEAR: lexico.trc('Input Label', 'Expiration Year'),
    EXP_YEAR_PLACEHOLDER: lexico.trc('Input placeholder', 'Select a year'),
    BILL_ADDRESS: lexico.trc('Input Label', 'Billing Address'),
    STREET_ADDRESS: lexico.trc('Input Label', 'Street Address'),
    CITY: lexico.trc('Input Label', 'City'),
    COUNTRY: lexico.trc('Input Label', 'Country'),
    STATE: lexico.trc('Input Label', 'State'),
    STATE_PLACEHOLDER: lexico.trc('Input placeholder', 'Select a state'),
    ZIP_CODE: lexico.trc('Input Label', 'Zip code'),
    POST_CODE: lexico.trc('Input Label', 'Postcode'),
    SUBMIT: lexico.trc('Button', 'Submit'),
    CANCEL: lexico.trc('Button', 'Cancel'),
    ROLE: lexico.trc('Input Label', 'Role'),
    ROLE_PLACEHOLDER: lexico.trc('Input placeholder', 'Select a role'),
    ENABLE_SELF_APPROVAL: lexico.trc('Input Label', 'Enable self-approval'),
    APPROVER: lexico.trc('Input Label', 'Approver'),
    APPROVER_PLACEHOLDER: lexico.trc('Input placeholder', 'Select a approver'),
    SEND_INVITATION: lexico.trc('Button', 'Send Invitation'),
    SUBMIT_SUCCESS: lexico.trc('Success message', 'Card name updated.'),
    SUBMIT_ERROR: lexico.trc('Error message', 'There was a problem updating the card name. Please try again.'),
};
exports.invitePeopleStrings = {
    APPROVER_MESSAGE: lexico.trc('Invite user validation message', 'This team must have an admin or manager before you can invite a member.'),
    SUCCESS_MESSAGE: ({ teamId, firstName, lastName }) => `${firstName} ${lastName} ${lexico.tr('was successfully invited')}${teamId ? '.' : lexico.tr(' to the team.')}`,
    SELF_APPROVER_LABEL: lexico.trc('Form select option', 'Self'),
    INVITE_USER_TITLE: (user) => lexico.trc('Title', `Invite new ${user?.toLowerCase() || 'user'}`),
    INVITE_NEW_USER: lexico.tr('Invite new user'),
};
exports.navigationStrings = {
    TEAM_INFO: lexico.trc('Component title', 'Team Information'),
    ADD_PEOPLE: lexico.trc('Component title', 'Add People'),
    CODING_LISTS: lexico.trc('Component title', 'Coding Lists'),
};
exports.peopleTableStrings = {
    NAME: lexico.trc('Data table column label', 'Name'),
    NAME_TIP: lexico.trc('Data table column tooltip', 'Search by name'),
    ROLE: lexico.trc('Data table column label', 'Role'),
    DEFAULT_APPROVER: lexico.trc('Data table column label', 'Default Approver'),
    STATUS: lexico.trc('Data table column label', 'Status'),
    WARNING_MESSAGE: lexico.trc('Warning message', 'There was a problem loading this teams users. Please try again.'),
    APPROVER_WARNING_MESSAGE: (fullName) => `${fullName} ${lexico.tr('is responsible for approving requests from other team members. Please assign a new approver to the impacted members to proceed.')}`,
    ONLY_USER_WARNING_MESSAGE: (fullName) => `${fullName} ${lexico.tr('is the only user in the team, cannot be a team member')}`,
    SUCCESS_MESSAGE: ({ fname }) => `${fname} ${lexico.tr('was removed')}`,
    USER_REMOVE_ERROR_MESSAGE: lexico.trc('Error message', 'There was an error removing the user. Please make sure that the user is not an approver for other users on the team and has no pending requests, and that there is at least one other approver on the team.'),
    ASIDE_TITLE: lexico.trc('Title', 'Select A Role'),
};
exports.notificationStrings = {
    SUCCESS: lexico.trc('type', 'success'),
    WARNING: lexico.trc('type', 'warning'),
    ERROR: lexico.trc('type', 'error'),
    INFO: lexico.trc('type', 'info'),
};
exports.messageStrings = {
    EMPTY_LIST_MESSAGE: lexico.trc('Empty list message', 'There are no team owners or managers to be selected.'),
    WARNING_MESSAGE: lexico.trc('Warning message', 'Your team has reached the maximum number of members (180). Please create a new team to invite additional members.'),
    UNIQUE_TEAM_NAME_ERROR_MESSAGE: lexico.trc('Error message', 'A team with this name already exists.'),
    TEAM_NAME_NOT_EMPTY: lexico.tr('The team name can not be empty.'),
    ERROR_MESSAGE: lexico.trc('Error message', 'There was an error please try again.'),
    SAVE_TEAM_ERROR_MESSAGE: lexico.trc('Error message', 'Something went wrong. Please try again.'),
    CARD_PROVIDER_WARNING_MESSAGE: lexico.trc('Warning message', 'Your bank returned an error while adding this card. Please contact your bank to resolve and try again.'),
    CARD_WARNING_ERROR: lexico.trc('Warning message', 'There was a problem adding the credit card. Please try again.'),
    CREDIT_CARD_SUCCESS_MESSAGE: lexico.trc('Success message', 'Credit card added.'),
};
exports.validationStrings = {
    REQUIRED_FIELD_ERROR: lexico.tr('This field is required'),
};
exports.userDetailsStrings = {
    NO_REQUEST_LIMIT_TEAM_TEXT: lexico.tr('If no value then team limit applies'),
    NO_REQUEST_LIMIT_COMPANY_TEXT: lexico.tr('If no value then company limit applies'),
    REQUEST_LIMIT_VALIDATION_TEXT: maxRequestLimit => `${lexico.tr('Should be less than or equal to')} ${maxRequestLimit}`,
    ACTIVE_CARD_USERS_ERROR: lexico.trc('Warning message', "Users with active cards can't be removed. Please cancel cards to remove this user."),
    PENDING_REQUEST_ERROR: lexico.trc('Warning message', "Can't remove user with pending requests."),
    NO_TEAM_OWNER_AND_MANAGER_ERROR: lexico.trc('Warning message', "Can't remove this user. You need at least one team owner or manager on a team."),
    HSBC_NOT_REMOVE_USER_ERROR_START: lexico.t('Sorry, we are not able to remove this user. This could be due to the following reasons, please ensure:'),
    HSBC_NOT_REMOVE_USER_ERROR_BULLETS: [
        lexico.t('there are no virtual cards linked to this user'),
        lexico.t('they don’t have pending virtual card requests'),
        lexico.t('they aren’t an approver for another user; and / or'),
        lexico.t('they are not the sole approver for this team.'),
    ],
    HSBC_NOT_REMOVE_USER_ERROR_END: lexico.t('Please check and try again.'),
    USER_REQUESTERS_ERROR: ({ firstName }) => `${firstName} ${lexico.tr('is responsible for approving requests from other team members. Please assign a new approver to the impacted members to proceed.')}`,
    REMOVE_USER_WARNING: ({ firstName }) => `${lexico.tr('Are you sure you want to remove from the team the following user')}: ${firstName}?`,
};
exports.addPeopleStrings = {
    ADD_PEOPLE_HEADER_TITLE: lexico.trc('Title', 'Add some people to this team'),
    ADD_PEOPLE_HEADER_SUBTITLE_AMEX: lexico.trc('Title', 'People in a team can have 3 different roles'),
    ADD_PEOPLE_HEADER_SUBTITLE_HSBC: lexico.trc('Title', 'People in a team can have 2 different roles'),
    TEAM_OWNERS_TEXT: lexico.trc('Input Label', 'Team owners'),
    TEAM_OWNER_DESC: lexico.trc('Description', 'Can view all requests and spend activity in the team. Team owners also get a team dashboard to track spend and team wallet where they can see all active cards.'),
    MANAGERS_TEXT: lexico.trc('Title', 'Managers'),
    MANAGERS_DESC: lexico.trc('Description', 'Can approve requests and create cards for members they manage. Managers have a dashboard to track spend for members they manage.'),
    MEMBERS_TEXT: lexico.trc('Title', 'Members'),
    MEMBERS_DESC: lexico.trc('Title', 'Can Request cards and have a wallet for all their cards. Each member gets a default approver (manager) for their requests.'),
    INVITE_PEOPLE_TEXT: lexico.trc('Title', 'Invite People'),
};
exports.teamInfoStrings = {
    INVALID_NUMBER_TEXT: lexico.tr('Please enter a positive integer or leave empty.'),
    HSBC_INVALID_NUMBER_TEXT: lexico.tr('Please enter a positive number or leave empty.'),
    EXCEEDS_COMPANY_LIMIT_TEXT: lexico.tr('This amount exceeds the company approval limit.'),
    EXCEEDS_TEAM_LIMIT_TEXT: lexico.tr('This amount exceeds the team approval limit.'),
    EXCEEDS_AMEX_APPROVAL_LIMIT_TEXT: lexico.tr('This amount exceeds the Max Approval Limit Per Virtual Card.'),
    SELECT_CARD_TEXT: lexico.tr('Select Card'),
    ENROLL_SOURCE_CARD: lexico.tr('Enroll Source Card'),
    ENROLL_PHYSICAL_CARD: lexico.tr('Enroll Physical Card'),
    ENROLL_CARD_MESSAGE: lexico.tr('Enroll your first corporate card to GO.'),
    BASIC_SETTINGS_TEXT: lexico.tr('Basic settings'),
    TEAM_NAME: lexico.trc('Input Label', 'Team Name'),
    TEAM_NAME_PLACEHOLDER: lexico.trc('Input placeholder', 'Enter a unique team name'),
    VIRTUAL_CARD_OPTIONS_TEXT: lexico.trc('Input Label', 'Virtual card options'),
    CREATED_TEXT: lexico.tr('Created'),
    CREATED_BY_TEXT: lexico.tr('Created By'),
    ACTIVE_CARDS_TEXT: lexico.tr('Active Cards'),
    MEMBERS_TEXT: lexico.tr('Members'),
};
exports.companySettingsCodingStrings = {
    CODING_LIST: lexico.trc('Input label', 'Coding list'),
    CODING_LIST_PUBLISHED: lexico.trc('Input label', 'Published'),
    PROVIDER_MAPPING: lexico.trc('Input label', 'Provider mapping'),
    UNIQUE_IDENTIFIER_COLUMN: lexico.trc('Table column', 'Unique identifier'),
    CODING_ENTRY_COLUMN: lexico.trc('Table column', 'Coding entry'),
    CODING_ENTRY_SAVE_SUCCESS: lexico.trc('Success message', 'Coding entry saved.'),
    CODING_ENTRY_SAVE_ERROR: lexico.trc('Warning message', 'Sorry, there was a problem saving the coding entry. Please try again.'),
    CODING_ENTRY_DUPLICATE_ERROR: ({ entryId }) => lexico.trc('Warning message', `A coding entry with ID '${entryId}' already exists.`),
    TEAMS_WHO_SEE_THIS_COLUMN: lexico.trc('Table column', 'Teams who see this'),
    UNIQUE_IDENTIFIER_PLACEHOLDER: lexico.trc('Input label', 'Enter a numeric id'),
    CODING_ENTRY_PLACEHOLDER: lexico.trc('Input label', 'Enter new entry'),
    REMOVE_ENTRY_CONFIRMATION_ASIDE_TITLE: lexico.trc('Form title', 'Confirm action'),
    REMOVE_ENTRY_CONFIRMATION_ASIDE_NOTE: ({ codingListEntryId, codingListEntryCode }) => `${lexico.tr('Delete coding ID:')} ${codingListEntryId}, ${lexico.tr('Entry:')} ${codingListEntryCode}`,
    REMOVE_LIST_CONFIRMATION_ASIDE_TITLE: lexico.trc('Form title', 'Remove list'),
    REMOVE_LIST_CONFIRMATION_ASIDE_NOTE: lexico.trc('Header title', 'Removing a list removes it from being used and ' +
        'deletes all existing entries. If you want to temporarily remove a list and keep the entries you can turn off ' +
        'the publish setting. Are you sure want to remove this list?'),
    CHANGE_TEAM_ASIDE_TITLE: lexico.trc('Form title', 'Select teams'),
    CHANGE_TEAM_ASIDE_ALL_TEAMS_OPTION: lexico.trc('Input label', 'All teams'),
    CHANGE_TEAM_ASIDE_SAVE_BUTTON: lexico.trc('Button', 'Save'),
    CREATE_NEW_LIST_BUTTON: lexico.trc('Button', 'Create new list'),
    CREATE_NEW_LIST_ASIDE_TITLE: lexico.trc('Form title', 'Add coding list'),
    CREATE_NEW_LIST_ASIDE_NOTE: lexico.trc('User notification message', 'Select from coding list ' + 'presets or create your own new list.'),
    CREATE_NEW_LIST_ASIDE_CUSTOM_CODING_BUTTON: lexico.trc('Button', 'Create custom list'),
    CREATE_NEW_CUSTOM_LIST_ASIDE_TITLE: lexico.trc('Form title', 'Create custom list'),
    CREATE_NEW_CUSTOM_LIST_INPUT_LABEL: lexico.trc('Input label', 'Custom list name'),
    CREATE_NEW_CUSTOM_LIST_BUTTON: lexico.trc('Button', 'Add list'),
    CREATE_NEW_CUSTOM_LIST_CANCEL_BUTTON: lexico.trc('Button', 'Cancel'),
    REMOVE_LIST_BUTTON: lexico.trc('Button', 'Remove list'),
    RENAME_LIST_BUTTON: lexico.trc('Button', 'Rename list'),
    RENAME_LIST_ASIDE_TITLE: lexico.trc('Form title', 'Edit custom list'),
    RENAME_LIST_INPUT_LABEL: lexico.trc('Input label', 'Custom list name'),
    RENAME_LIST_INPUT_BUTTON: lexico.trc('Button', 'Rename coding list'),
    RENAME_LIST_INPUT_CANCEL_BUTTON: lexico.trc('Button', 'Cancel'),
    NO_CODING_LIST_PANEL_HEADER: lexico.trc('Header', 'Accounting Codes'),
    NO_CODING_LIST_PANEL_PARAGRAPH: lexico.trc('Note', 'Accounting codes are managed through coding ' +
        "lists and entries in lists. You currently haven't created any coding lists. Coding lists can be created " +
        'at the company level and entries in lists can be made specific to teams as needed.'),
    NO_CODING_LIST_BUTTON: lexico.trc('Button', 'Add coding list'),
    NO_CODING_TEXT: lexico.trc('title', 'You don’t have any accounting codes created for this account.'),
    NO_CODING_SUB_TEXT: lexico.trc('title', 'You can create accounting codes in company settings.'),
    CODING_ENTRY_DELETE_MESSAGE: lexico.trc('Success message', 'Coding entry deleted'),
};
exports.companySettingsCardStrings = {
    HEADER_TITLE: lexico.trc('Component title', 'Company Settings'),
    TABLE_ID: lexico.trc('Component title', 'CardsTable'),
    ENROLL_NEW_CARD: lexico.trc('Button', 'Enroll card'),
};
exports.teamSettingsCardStrings = {
    TABLE_ID: lexico.trc('Component title', 'CardsTable'),
    ADD_SOURCE_CARD: lexico.trc('Button', 'Add source card'),
    ADD_PHYSICAL_CARD: lexico.trc('Button', 'Add physical card'),
};
exports.teamSettingsPeopleStrings = {
    INVITE_PEOPLE: lexico.trc('Button', 'Invite People'),
};
exports.enrollSourceCardStrings = {
    CARD_HEADER_TEXT: lexico.trc('Component title', 'Enroll source card'),
    CARD_HEADER_TEXT_HSBC: lexico.trc('Component title', 'Enroll physical card'),
    SUBMIT_BUTTON_TEXT: lexico.trc('Button', 'Submit'),
    CARD_HOLDER_FIELD_TEXT: lexico.trc('Form field title', 'Card holder'),
    FIRST_NAME_FIELD_TEXT: lexico.trc('Form input label', 'First name'),
    LAST_NAME_FIELD_TEXT: lexico.trc('Form input label', 'Last name'),
    EMAIL_FIELD_TEXT: lexico.trc('Input field label', 'Email'),
    CARD_DETAILS_FIELD_TEXT: lexico.trc('Form field title', 'Card details'),
    CARD_NAME_FIELD_TEXT: lexico.trc('Input field label', 'Card name'),
    CARD_NAME_PLACEHOLDER_TEXT: lexico.trc('Input field placeholder', 'A friendly nickname, e.g. Marketing Card'),
    CARD_NUMBER_PLACEHOLDER_TEXT: lexico.trc('Input field placeholder', 'XXXX XXXXXX XXXXX'),
    CARD_NUMBER_FIELD_TEXT: lexico.trc('Input field label', 'Card number'),
    EXP_MONTH_FIELD_TEXT: lexico.trc('Field input label', 'Expiration Month'),
    EXP_MONTH_PLACEHOLDER_TEXT: lexico.trc('Placeholder text', 'Select a month'),
    EXP_YEAR_FIELD_TEXT: lexico.trc('Field input label', 'Expiration Year'),
    SELECT_YEAR_TEXT: lexico.trc('Placeholder text', 'Select a year'),
    BILLING_ADDRESS_FIELD_TEXT: lexico.trc('Form field title', 'Billing address'),
    STREET_ADDRESS_FIELD_TEXT: lexico.trc('Input field label', 'Street address'),
    CITY_FIELD_TEXT: lexico.trc('Input field label', 'City'),
    STATE_FIELD_TEXT: lexico.trc('Form input label', 'State'),
    STATE_PLACEHOLDER_TEXT: lexico.trc('Placeholder text', 'Select a state'),
    ZIPCODE_FIELD_TEXT: lexico.trc('Input field label', 'Zip code'),
};
exports.cardDetailStrings = {
    CARD_DETAILS_ASIDE_TITLE_TEXT: lexico.trc('Component title', 'Card details'),
    SAVE_BUTTON_TEXT: lexico.trc('Button', 'Save'),
    CARD_NAME_FIELD_TEXT: lexico.trc('Input field label', 'Card name'),
    TEAMS_USING_CARD_TEXT: lexico.trc('Form field title', 'Teams using the card'),
    REMOVE_SOURCE_CARD_INFO_TEXT: lexico.trc('Info message', 'Removing a source card from a team will not disable existing virtual cards.'),
    REMOVE_PHYSICAL_CARD_INFO_TEXT: lexico.trc('Info message', 'Removing a physical card from a team will not disable existing virtual cards.'),
    ADDITIONAL_CARD_DETAILS_TEXT: lexico.trc('Form field title', 'Additional card details'),
    CARDHOLDER_NAME_FIELD_TEXT: lexico.trc('Form field title', 'Cardholder name'),
    LAST_4_DIGITS_FIELD_TEXT: lexico.trc('Form field title', 'Last 4 digits'),
    CURRENCY_FIELD_TEXT: lexico.trc('Form field title', 'Currency'),
    BILLING_ADDRESS_FIELD_TEXT: lexico.trc('Form field title', 'Billing address'),
    REMOVE_FROM_TEAM_BUTTON_TEXT: lexico.trc('Button', 'Remove from team'),
    REMOVE_CARD_ASIDE_TITLE_TEXT: lexico.trc('Aside component title', 'Remove Card'),
    ALL_TEAMS_LABEL_TEXT: lexico.trc('Select all label', 'All teams'),
    APPLY_BUTTON_TEXT: lexico.trc('Button label', 'Apply'),
    SELECT_TEAMS: lexico.trc('Aside component title', 'Select teams'),
    SELECT_TEAMS_SUBMIT_SUCCESS: lexico.trc('Success message', 'Teams updated.'),
    SELECT_TEAMS_SUBMIT_ERROR: lexico.trc('Error message', 'There was a problem updating the teams. Please try again.'),
    CANT_REMOVE_CARD: lexico.trc('Card removal warning message', 'You can not remove the only source card linked to this team. Add another card in order to remove this one.'),
    HSBC_CANT_REMOVE_CARD: lexico.trc('Card removal warning message', "You can't remove the only physical card linked to this team. Add another card in order to remove this one."),
    REMOVE_CARD: lexico.trc('Card removal warning message', 'Removing a source card from a team will not disable existing virtual cards. Are you ' +
        'sure you want to remove this card from this team?'),
    HSBC_REMOVE_CARD: lexico.trc('Card removal warning message', 'Removing a physical card from a team will not disable existing virtual cards. Are you ' +
        'sure you want to remove this card from this team?'),
    REMOVE_CARD_SUCCESS: lexico.trc('Success message', 'This source card was removed from the team.'),
    HSBC_REMOVE_CARD_SUCCESS: lexico.trc('Success message', 'This physical card was removed from the team.'),
    REMOVE_CARD_ERROR: lexico.trc('Error message', 'There was a problem removing the source card from the team. Please try again.'),
    INVALID_CARD_NUMBER: lexico.trc('Error message', 'Please enter a valid card number.'),
    INVALID_EMAIL_FORMAT: lexico.trc('Error message', 'Please enter a valid email address.'),
    REGION_REQUIRED: lexico.trc('Error message', 'Please enter a valid country.'),
    INVALID_REGION_FORMAT: lexico.trc('Error message', 'Country is required.'),
    MIN_REGION_LENGTH: lexico.trc('Error message', 'The Country must be at least 2 characters long.'),
    MAX_REGION_LENGTH: lexico.trc('Error message', 'The Country must not be more than 27 characters long.'),
    INVALID_EMAIL_VALIDATION_BY_PROVIDER: lexico.tr("Email address cannot include the '+' character."),
    DUPLICATE_CARD_ERROR: ({ cardName }) => lexico.trc('Warning message', `A card name with '${cardName}' already exists.`),
    INVALID_ENTRY_WARNING: ({ field }) => lexico.trc('Warning message', `Enter a valid ${field}.`),
    ADD_NEW_CARD_TEXT: lexico.trc('Component title', 'Add new card'),
    ADD_CARD_SOURCE_INSTRUCTIONS_TEXT: lexico.trc('User instructions', 'Link one of these source cards to this team or enroll a new one.'),
    HSBC_ADD_CARD_SOURCE_INSTRUCTIONS_TEXT: lexico.trc('User instructions', 'Link one of these physical cards to this team or enroll a new one.'),
    ENROLL_NEW_CARD_BUTTON_TEXT: lexico.trc('Button', 'Enroll a new card'),
    CANCEL_BUTTON_TEXT: lexico.trc('Button', 'Cancel'),
    CREDIT_CARD_LINK_SUCCESS_MESSAGE: lexico.trc('Success message', 'This source card has been added to the team.'),
    HSBC_CREDIT_CARD_LINK_SUCCESS_MESSAGE: lexico.trc('Success message', 'This physical card has been added to the team.'),
    CREDIT_CARD_LINK_ERROR_MESSAGE: lexico.trc('Warning message', 'There was a problem adding the source card to the team. Please try again'),
    YES_BUTTON_TEXT: lexico.trc('Button', 'Yes'),
};
exports.sideMenuStrings = {
    SIDE_MENU_DASHBOARD_OPTION: lexico.trc('Button', 'Dashboard'),
    SIDE_MENU_APPROVALS_OPTION: lexico.trc('Button', 'Approvals'),
    SIDE_MENU_WALLET_OPTION: lexico.trc('Button', 'Wallet'),
    SIDE_MENU_MY_REQUESTS_OPTION: lexico.trc('Button', 'My Requests'),
    SIDE_MENU_TEAM_SWITCHER_OPTION: lexico.trc('Button', 'Team Switcher'),
    SIDE_MENU_MANAGE_SETTLEMENTS_OPTION: lexico.trc('Button', 'Manage Settlements'),
    SIDE_MENU_MANAGE_TRANSACTIONS_OPTION: lexico.trc('Button', 'Manage Transactions'),
    SIDE_MENU_TEAM_SETTINGS_OPTION: lexico.trc('Button', 'Team Settings'),
    SIDE_MENU_COMPANY_SETTINGS_OPTION: lexico.trc('Button', 'Company Settings'),
    SIDE_MENU_SUPPORT_SETTINGS_OPTION: lexico.trc('Button', 'Support Settings'),
    SIDE_MENU_CREATE_NEW_REQUEST_BUTTON: lexico.trc('Button', 'Create New Request'),
    SWITCH_TEAM_ERROR_MESSAGE: lexico.trc('Error message', "We're unable to switch team at this time. Please try again later."),
    SUPPORT: lexico.trc('Button', 'Support'),
};
exports.sessionStrings = {
    ENTER_YOUR_AUTH_APP_CODE_HSBC: lexico.tr('Enter a code from your authentication app'),
    ENTER_YOUR_AUTH_APP_CODE_AMEX: lexico.tr('Enter your authenticator app code'),
    CONTINUE: lexico.tr('Continue'),
    CONFIRM_PASSWORD: lexico.tr('Confirm Password'),
};
exports.sessionUserDetailsStrings = {
    INVALID_IMAGE_FILE_FORMAT: lexico.trc('Error message', 'Please select an image file.'),
    PROFILE_PIC_INPUT_LABEL_TEXT: lexico.trc('Form input title', 'Profile picture'),
    FIRST_NAME_INPUT_LABEL_TEXT: lexico.trc('Form input title', 'First name'),
    LAST_NAME_INPUT_LABEL_TEXT: lexico.trc('Form input title', 'Last name'),
    EMAIL_INPUT_LABEL_TEXT: lexico.trc('Form input title', 'Email'),
    PHONE_INPUT_LABEL_TEXT: lexico.trc('Form input title', 'Phone number'),
    COMPANY_INPUT_LABEL_TEXT: lexico.trc('Form input title', 'Company'),
    TEAM_INPUT_LABEL_TEXT: lexico.trc('Form input title', 'Team'),
    ROLE_INPUT_LABEL_TEXT: lexico.trc('Form input title', 'Role'),
    LANGUAGE_INPUT_LABEL_TEXT: lexico.trc('Select input title', 'Language'),
    SAVE_BUTTON_TEXT: lexico.trc('Button', 'Save'),
    REMOVE_FROM_TEAM_TEXT: lexico.trc('Button', 'Remove from Team'),
    CANCEL_BUTTON_TEXT: lexico.trc('Button', 'Cancel'),
    OUT_OF_OFFICE_BUTTON_TEXT: lexico.trc('Button', 'Out Of Office'),
    SAVE_ERROR_MESSAGE: lexico.trc('Error message', 'There was a problem saving the profile. Please try again.'),
    SAVE_AVATAR_ERROR_MESSAGE: lexico.trc('Error message', 'There was a problem saving the avatar. Please try again.'),
    SAVE_SUCCESS_MESSAGE: lexico.trc('Success message', 'Profile saved!'),
};
exports.approvalsStrings = {
    FORWARD_REQUEST: lexico.trc('Title', 'Forward request'),
    SELECT_APPROVER: lexico.trc('Form input title', 'Select Approver'),
    APPROVER_PLACEHOLDER: lexico.trc('Input field placeholder', 'Select a user to forward the request to'),
    REASON: lexico.trc('Form input title', 'Reason'),
    REASON_PLACEHOLDER: lexico.trc('Input field placeholder', 'The reason will be visible to the approver and the requester'),
    FORWARD_BUTTON: lexico.trc('Button', 'Forward'),
    FWD_CANCEL_BUTTON: lexico.trc('Button', 'Cancel'),
    REASSIGN_MESSAGE: lexico.trc('Message', 'Are you sure you want to re-assign this request back to you?'),
    VIEW_ALL_APPROVALS_TEXT: lexico.trc('Toggle text', 'View All Approvals'),
    NO_APPROVERS_TEXT: lexico.trc('Empty option', 'You can only forward the request to another team owner.'),
};
exports.walletStrings = {
    BILLING_ADDRESS: lexico.tr('Billing address'),
    CARD_NAME: lexico.tr('Card name'),
    BUSINESS_JUSTIFICATION: lexico.tr('Business justification'),
    VIEW_CARD_ACTIVITY_BUTTON: lexico.trc('Button', 'View Card Activity'),
    VIEW_CONVERSATION_BUTTON: lexico.trc('Button', 'View Conversation'),
    CARDHOLDER_NAME_FIELD_TEXT: lexico.trc('Form field title', 'Cardholder name'),
    LAST_4_DIGITS_FIELD_TEXT: lexico.trc('Form field title', 'Last 4 digits'),
    EXPIRY_DATE_FIELD_TEXT: lexico.trc('Form field title', 'Expiry date'),
    ISSUED_ON_FIELD_TEXT: lexico.trc('Form field title', 'Issued on'),
    APPROVED_BY_FIELD_TEXT: lexico.trc('Form field title', 'Approved by'),
    SOURCE_CARD_NAME_FIELD_TEXT: lexico.trc('Form field title', 'Source card name'),
    HSBC_PHYSICAL_CARD_NAME_FIELD_TEXT: lexico.trc('Form field title', 'Physical card name'),
    VIRTUAL_CARD_END_DATE: lexico.tr('Virtual card end date'),
    VIRTUAL_CARD_CAN_BE_USED_UNTIL: lexico.tr('Virtual card can be used until'),
    CANCEL_CARD_BUTTON: lexico.trc('Button', 'Cancel card'),
    CANCEL_CARD_SUCCESS: lexico.trc('Button', 'The card was cancelled.'),
    CANCEL_CARD_ERROR: lexico.trc('Button', 'Could not cancel the card!'),
    VIEW_REQUEST: lexico.trc('Button', 'View Request'),
    CANCEL_CARD_MESSAGE_TEXT: lexico.trc('Confirmation message', 'Cancelling this card will not reverse any pending charges. Please look for the settlement records for those charges in the credit card statement sent by your card provider. Are you sure you want to cancel?'),
    HSBC_CANCEL_CARD_MESSAGE_TEXT: lexico.trc('Confirmation message', 'Please check your credit card statement to review your transactions. Are you sure you want to cancel?'),
    USE_THIS_CARD_BUTTON: lexico.trc('Button', 'Use this card'),
    SETTLEMENT_INFO_TEXT: lexico.trc('Settlement information message', 'Settlement amount could be different if tips or other fees are applied to the purchase'),
    TRANSACTION_INFO_TEXT: lexico.trc('Transaction information message', 'Transaction amounts do not include fees, these are available on Business Internet Banking and your physical card statement'),
    SETTLEMENT_TITLE_TEXT: lexico.trc('title', 'Settlements'),
    TRANSACTIONS_TITLE_TEXT: lexico.trc('title', 'Transactions'),
    NO_SETTLEMENT_TEXT: lexico.trc('Empty settlements message', 'No settlements have been posted yet.'),
    NO_TRANSACTIONS_TEXT: lexico.trc('Empty settlements message', 'No transactions have been posted yet.'),
    VIEW_RECEIPT_TEXT: lexico.trc('Button', 'View Receipt'),
    REMOVE_RECEIPT_TEXT: lexico.trc('Button', 'Remove Receipt'),
    UPLOAD_RECEIPT_TEXT: lexico.trc('Text', 'Upload Receipt'),
    RECEIPT_UPLOAD_SUCCESS: lexico.trc('Upload success', 'Receipt attached'),
    RECEIPT_UPLOAD_ERROR: lexico.trc('Error message', 'Upload failed, try again.'),
    RECEIPT_REMOVED_SUCCESS: lexico.trc('Upload success', 'Receipt removed'),
    RECEIPT_REMOVED_ERROR: lexico.trc('Error message', 'Remove receipt failed, try again.'),
    MAXIMUM_CHARS: lexico.trc('Error message', 'You have entered the maximum allowed characters!'),
    HSBC_MAXIMUM_CHARS: lexico.trc('Error message', 'You have entered the maximum number of allowed characters.'),
};
exports.SupportSettingsStrings = {
    GO_VERSION_TEXT: lexico.trc('text', 'Go Version'),
    REQUEST_PROFILE_TEXT: lexico.trc('text', 'Request Profile'),
    PROVIDER_API_MAPPING_TEXT: lexico.trc('text', 'Provider API Mapping'),
    WORKFLOW_CONFIG_TEXT: lexico.trc('text', 'Workflow Config'),
    OUT_OF_OFFICE_TEXT: lexico.trc('text', 'Out-of-Office'),
    ACTIVITY_TEXT: lexico.trc('text', 'Activity'),
    OOO_TOGGLE_TEXT: lexico.trc('text', 'Enable automatic forwarding of approval requests'),
    ACTIVITY_TOGGLE_TEXT: lexico.trc('text', 'Enable activity menu option for company admins'),
    READ_LINK_BUTTON: lexico.trc('Button', 'Read link'),
    SET_LINK_BUTTON: lexico.trc('Button', 'Set link'),
    CLEAR_LINK_BUTTON: lexico.trc('Button', 'Clear link'),
    LINK_GO_BRANCH: lexico.trc('Link title', 'Link Go Branch'),
    MASTER_BRANCH_ID_PLACEHOLDER: lexico.trc('Placeholder', 'Master Branch id'),
    GO_BRANCH_ID_PLACEHOLDER: lexico.trc('Placeholder', 'GO Branch id'),
    REQUEST_ID_PLACEHOLDER: lexico.trc('Placeholder', 'Request id'),
    FORCE_CLOSE_STUCK_APPROVAL: lexico.trc('title', 'Force Close Stuck Approval'),
    USE_WITH_CAUTION_TEXT: lexico.trc('text', `USE WITH CAUTION! This is a workaround for approvals that are stuck in pending state. Could lead
						to data inconsistency and use it as a last standing option to close an approval, by providing
						the request id in the input above.
						Will delete the approval if there is no virtual card created, and otherwise will complete
						the approval if there is a virtual card created.`),
    CLOSE_APPROVAL_BUTTON: lexico.trc('Button', 'Close Approval'),
};
exports.dashboardStrings = {
    COMPANY_DASHBOARD: lexico.trc('title', 'Company Dashboard'),
    SPEND_DASHBOARD: lexico.trc('title', 'Spend Dashboard'),
    OVERVIEW: lexico.trc('sub title', 'Overview (Active cards only)'),
    SPEND_OVER_TIME: lexico.trc('sub title', 'Spend Over Time'),
    TEAMS: lexico.trc('sub title', 'Teams (Active cards only)'),
    TEAM_MEMBERS: lexico.trc('sub title', 'Team Members (Active cards only)'),
    ACTIVE_CARDS: lexico.trc('info', 'Active Cards'),
    ACTIVE_VIRTUAL_CARDS: lexico.trc('info', 'Active Virtual Cards'),
    AVAILABLE_BALANCE: lexico.trc('info', 'Available Balance'),
    APPROVED_AMOUNT: lexico.trc('info', 'Approved Amount'),
    SPENT_AMOUNT: lexico.trc('info', 'Spent Amount'),
    NO_DATA: lexico.trc('message', 'No data to display'),
    TEAM_DASHBOARD: lexico.trc('menu item', 'Team Dashboard'),
    TEAM_SETTINGS: lexico.trc('menu item', 'Team Settings'),
    TEAM_FIELD: lexico.trc('table field', 'Team'),
    MEMBER_FIELD: lexico.trc('table field', 'Members'),
    ACTIVE_CARDS_FIELD: lexico.trc('table field', 'Active Cards'),
    APPROVED_FIELD: lexico.trc('table field', 'Approved'),
    SPENT_FIELD: lexico.trc('table field', 'Spent'),
    AVALIABLE_FIELD: lexico.trc('table field', 'Available'),
    TOTAL_SPENT: lexico.trc('info', 'Total Spent'),
    NUMBER_OF_TRANSACTIONS: lexico.trc('info', '# of transactions'),
};
exports.errorStrings = {
    DEFAULT: lexico.trc('Error message', 'Sorry, we are having technical difficulties. Please try again later.'),
    HSBC_PAGE_NOT_FOUND_HEADER: lexico.trc('Error message', 'Page not found (404)'),
    HSBC_PAGE_NOT_FOUND_DESCRIPTION: lexico.trc('Error message', "We are sorry, that page can't be found. The page may have been moved or deleted. Please try finding the new page from the homepage navigation."),
    HSBC_PAGE_NOT_FOUND_BUTTON: lexico.trc('Button', 'Go to homepage'),
    AMEX_CARD_CREATION: lexico.trc('Error message', "New virtual cards can't be created at this time. Please contact your program administrator for more details."),
    HSBC_CARD_CREATION: lexico.trc('Error message', "New virtual cards can't be created at this time. Please contact your administrator for more details."),
};
